import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { selectData } from '../../../utils/select-data';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const requestSchema = z.object({
  users: z.array(
    z.object({
      id: z.number(),
      email: z.string(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
    })
  ),
  password: z.string(),
  forcePasswordReset: z.boolean(),
  alias: z.string(),
});

/**
 * Sets specified password for a list of users
 * @param users array of auth users to update
 * @param password new password to set for users
 * @param forcePasswordReset force user to reset password on next login
 * @param alias account alias
 * @returns array of updated users
 */
export function postPasswordResetBulk(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(`${authwsEnvironment.resolve(this).passwordResetUrl}/bulk`, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(
    selectData(
      z.array(
        z.object({
          id: z.number(),
          email: z.string(),
          firstName: z.string(),
          lastName: z.string(),
          migratedToTrimbleIdentity: z.boolean().nullable(),
          lastLogin: z.string().nullable(),
        })
      )
    )
  );
}
